import React, { useState } from 'react'

import { LoadingSpinner } from '@frame/ui-components/loading-spinner'
import { Alert } from '@frame/ui-primitives/alert'
import { Button } from '@frame/ui-primitives/button'
import { Span } from '@frame/ui-primitives/span'

import { DirectTask, DirectTaskState } from '@frame/lib/api/tasks/types'
import { useRootContext } from '@frame/lib/context'
import { useAutoNavigate } from '@frame/lib/hooks/useAutoNavigate'
import { DataAttribute } from '@frame/types'
import { Transition } from '@headlessui/react'

type Props = {
  task: DirectTask
}

export function SkipEmployer({ task }: Props) {
  const { mutateAndNavigate } = useAutoNavigate()
  const { actions } = useRootContext()
  const [isSkipping, setIsSkipping] = useState(false)
  const [failedToSkip, setFailedToSkip] = useState(false)

  async function handleClick() {
    setIsSkipping(true)
    const res = await actions.skipDirectTask(task.id)
    setIsSkipping(false)

    if (res?.state === DirectTaskState.SKIPPED) {
      mutateAndNavigate()
    } else {
      setFailedToSkip(true)
    }
  }

  return (
    <>
      <div className="mb-3 mt-4 flex items-center justify-between rounded-md border-2 border-moss-200 p-4">
        <div>
          <Span className="text-sm">Having trouble verifying?</Span>
        </div>
        <div>
          <Button
            data-cy={DataAttribute.BTN_SKIP_EMPLOYER}
            Icon={isSkipping ? () => <LoadingSpinner className="h-3 w-3" /> : undefined}
            disabled={isSkipping}
            size="small"
            intent="tertiary"
            onClick={handleClick}
          >
            Skip
          </Button>
        </div>
      </div>
      <Transition
        as="div"
        show={failedToSkip}
        enter="transition ease-in-out duration-300 transform"
        enterFrom="opacity-0 translate-y-[100%]"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-300 transform"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-[100%]"
        className="absolute bottom-0 left-0 m-4 w-[calc(100%-32px)]"
      >
        <Alert variant="error">Failed to skip employer. Please try again.</Alert>
      </Transition>
    </>
  )
}
